import { M as Menu, d as defineCustomElement$1 } from './menu.js';

const TtMenu = Menu;
const defineCustomElement = defineCustomElement$1;

export { TtMenu, defineCustomElement };
